var _path, _g, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseIcon = function SvgHouseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9194 12.0969V7.66139H45.5645V16.5324L48.0861 18.8247C48.7624 19.4395 48.3274 20.5646 47.4134 20.5646H44.7581V46.1775C44.7581 46.7298 44.3103 47.1775 43.7581 47.1775H5.83871C5.28643 47.1775 4.83871 46.7298 4.83871 46.1775V20.5646H2.8686C1.92138 20.5646 1.50499 19.3702 2.24694 18.7813L25.4032 0.40332L39.9194 12.0969Z",
    fill: "#EC960B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_17524_23519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9512 12.0967L36.2904 21.7151V37.7096C36.2904 38.2619 35.8427 38.7096 35.2904 38.7096H13.9033C13.351 38.7096 12.9033 38.2619 12.9033 37.7096V21.3465L24.9512 12.0967Z",
    fill: "#FFCB53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17524_23519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.731 20.9678L29.0321 24.2723V30.4516C29.0321 31.0039 28.5844 31.4516 28.0321 31.4516H21.1611C20.6088 31.4516 20.1611 31.0039 20.1611 30.4516V24.134L24.731 20.9678Z",
    fill: "#FDFCD0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    filter: "url(#filter2_f_17524_23519)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1459 21.3003L21.2379 23.9392C21.8067 25.3138 23.1477 26.2102 24.6352 26.2102C26.084 26.2102 27.3977 25.3594 27.9903 24.0374L29.1585 21.4314C30.6139 18.1846 28.2385 14.5166 24.6804 14.5166C21.1838 14.5166 18.809 18.0694 20.1459 21.3003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_17524_23519",
    x: 11.9033,
    y: 12.0967,
    width: 25.3867,
    height: 28.6133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.633333 0 0 0 0 0.332072 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17524_23519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_17524_23519",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_17524_23519"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17524_23519",
    x: 19.1611,
    y: 20.9678,
    width: 10.8711,
    height: 12.4834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.633333 0 0 0 0 0.332072 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17524_23519"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_17524_23519",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_17524_23519",
    x: 12.7676,
    y: 7.5166,
    width: 23.8262,
    height: 25.6934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_17524_23519"
  })))));
};
export { SvgHouseIcon as ReactComponent };
export default __webpack_public_path__ + "house-icon.svg";